export const enum UserManagementListMenuActions {
    PROMOTE_TO_ADMIN = 'promote to admin',
    DEMOTE_ADMIN = 'demote admin',
    BLOCK = 'block user',
    UNBLOCK = 'unblock user',
    RESEND_INVITATION = 'resend invitation',
    RESET_PASSWORD = 'reset password',
}
